<template>
  <div class="content">
    <h1>{{ fullname }}</h1>

    <ul class="tabs tabs--wrap">
      <router-link
        v-if="!isFormExist"
        :to="{ name: 'abiturient.form.new', query: route.query }"
        class="tabs__item"
      >
        Мои данные
      </router-link>
      <template v-else>
        <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'form' }" :to="{ name: 'abiturient.index', params: { tab: 'form' } }">Мои данные</router-link>
        <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'applications' }" :to="{ name: 'abiturient.index', params: { tab: 'applications' } }">Заявления</router-link>
        <router-link v-if="hasExams" class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'exams' }" :to="{ name: 'abiturient.index', params: { tab: 'exams' } }">Экзамены</router-link>
        <router-link v-if="hasRatingListItems" class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'contest_list'}" :to="{ name: 'abiturient.index', params: { tab: 'contest_list' } }">Моя конкурсная ситуация</router-link>
    </template>
    </ul>

    <div v-if="loading" class="content content--center">
      <p>Загрузка...</p>
    </div>
    <component
      v-else-if="isFormExist"
      :is="TABS[activeTab]"
      :form="abiturientStore.form"
      :applications="abiturientStore.applications"
      @select="(app) => router.push({ name: 'abiturient.application', params: { id: app.id, section: 'overview' } })"
      @refetch-form="fetchAbiturientForm"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAbiturientStore } from '@pages/abiturient'
import { FormProfileFormTab, FormProfileApplicationsTab, FormProfileExamsTab, FormProfileContestTab } from '@widgets/form-profile'

const route = useRoute()
const router = useRouter()
const abiturientStore = useAbiturientStore()

const TABS = {
  form: FormProfileFormTab,
  applications: FormProfileApplicationsTab,
  exams: FormProfileExamsTab,
  contest_list: FormProfileContestTab,
}

const isFormExist = computed(() => !!abiturientStore.form?.id || !!gon.user?.is_form_exist)
const fullname = window.gon?.user?.fullname
const loading = ref(!!gon.user?.is_form_exist)
const activeTab = computed(() => route.params.tab || 'form')
const applications = computed(() => abiturientStore.applications ?? [])

const hasExams = computed(() =>
  applications.value.some(application => application.entrance_exams?.length)
)

const hasRatingListItems = computed(() =>
  applications.value.some(application => application.rating_lists?.some(list => list.items?.length))
)

const fetchAbiturientForm = async (showLoading = false) => {
  if (showLoading) loading.value = true
  try {
    await abiturientStore.fetchForm()
  } finally {
    if (showLoading) loading.value = false
  }
}

onMounted(async () => {
  if (gon.user?.is_form_exist) await fetchAbiturientForm(true)
  loading.value = false
})
</script>
